export type {
  SavedCourseSnackbarState,
  SavedCoursesLocaleKeys,
  SavedCoursesProps,
} from './types';

export { default as SavedCourses } from './LazySavedCourses';
